import React, { CSSProperties } from 'react';
import triangleImage from './Triangle.svg';

interface RoundedTriangleImageProps {
  size?: number;
  position?: 'bottom-center' | 'top-center' | 'left-center' | 'right-center';
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
}

const RoundedTriangleImage: React.FC<RoundedTriangleImageProps> = ({
  size = 40,
  position = 'top-center',
  className = '',
  style = {},
  onClick
}) => {
  const getRotation = (): number => {
    switch (position) {
      case 'top-center': return 0;
      case 'left-center': return -90;
      case 'right-center': return 90;
      case 'bottom-center': return 180;
    }
  };

  const containerStyle: CSSProperties = {
    position: 'absolute', // ✅ makes it float
    width: size,
    height: size,
    cursor: onClick ? 'pointer' : 'default',
    ...style,
  };

  const imageStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    display: 'block',
    transform: `rotate(${getRotation()}deg)`,
  };

  // Positioning
  switch (position) {
    case 'top-center':
    //   containerStyle.top = 0;
      containerStyle.left = '50%';
      containerStyle.transform = 'translateX(-50%)';
      break;
    case 'left-center':
      containerStyle.left = 0;
      containerStyle.top = '50%';
      containerStyle.transform = 'translateY(-50%)';
      break;
    case 'right-center':
      containerStyle.right = 0;
      containerStyle.top = '50%';
      containerStyle.transform = 'translateY(-50%)';
      break;
    case 'bottom-center':
    default:
      containerStyle.bottom = 0;
      containerStyle.left = '50%';
      containerStyle.transform = 'translateX(-50%)';
      break;
  }

  return (
    <div style={containerStyle} className={className} onClick={onClick}>
      <img
        src={triangleImage}
        alt={`Triangle pointing ${position.split('-')[0]}`}
        style={imageStyle}
        draggable={false}
      />
    </div>
  );
};

export default RoundedTriangleImage;